import React from 'react';
import PointIcon from '../../assets/point-icon.svg';

const TwigsBadge = ({ 
  totalTwigsGiven = 0,
  transactionCount = 0,
  mostRecentDate,
  mostRecentAmount,
  averageBiasWeight = 0,
  size = 'sm',
  showTooltip = true 
}) => {
  if (totalTwigsGiven === 0) {
    return null;
  }

  const isLarge = size === 'lg';
  const formattedDate = mostRecentDate ? new Date(mostRecentDate).toLocaleDateString() : null;

  return (
    <div className="relative group">
      <div 
        className={`
          inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full 
          border border-growth-green-300 bg-growth-green-50 text-growth-green-700
          transition-all duration-200 cursor-default
          ${isLarge ? 'text-sm' : 'text-xs'}
        `}
      >
        <img src={PointIcon} alt="Twigs" className={`${isLarge ? 'h-4 w-4' : 'h-3 w-3'}`} />
        <span className="font-semibold">
          {totalTwigsGiven} {totalTwigsGiven === 1 ? 'Twig' : 'Twigs'} Given
        </span>
      </div>
      
      {showTooltip && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap">
          <div className="flex flex-col gap-1">
            <div className="flex items-center justify-between gap-4">
              <span>Total Given:</span>
              <span className="font-semibold">{totalTwigsGiven} Twigs</span>
            </div>
            <div className="flex items-center justify-between gap-4">
              <span>Transactions:</span>
              <span className="font-semibold">{transactionCount}</span>
            </div>
            {mostRecentAmount && (
              <div className="flex items-center justify-between gap-4">
                <span>Last Amount:</span>
                <span className="font-semibold">{mostRecentAmount} Twigs</span>
              </div>
            )}
            {formattedDate && (
              <div className="flex items-center justify-between gap-4">
                <span>Last Given:</span>
                <span className="font-semibold">{formattedDate}</span>
              </div>
            )}
            {averageBiasWeight > 0 && (
              <div className="flex items-center justify-between gap-4">
                <span>Avg. Weight:</span>
                <span className="font-semibold">{averageBiasWeight.toFixed(2)}</span>
              </div>
            )}
          </div>
          {/* Tooltip arrow */}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
        </div>
      )}
    </div>
  );
};

export default TwigsBadge;
